<!-- <div>
<button class="btn btn-light me-2" (click)="switchTheme('light')">Tema Claro</button>
<button class="btn btn-dark" (click)="switchTheme('dark')">Tema Oscuro</button>
</div> -->
@if (loadingRouteConfig()) {
  <div class="my-loading-progress-g app-route-config-loading">
    <div class="loading-progress-g"></div>
  </div>
}

<div class="root-router-shell" [@routeAnimation]="getAnimationData()">
  <router-outlet></router-outlet>
</div>

@let connectionStatus = connectivityService.status();
@if (connectionStatus !== ConnectivityStatusEnum.ONLINE) {
  <div class="connection-status connection-status--{{ connectionStatus }}" role="status" aria-live="polite">
    {{ "connection." + connectionStatus | translate }}
  </div>
}

<app-query-error-alert
  [isActive]="userDataService.noLoad() || domainService.noLoad()"
></app-query-error-alert>

<app-custom-toast></app-custom-toast>